const isPresent = (value: unknown): value is string | number =>
  value !== null && value !== undefined && String(value).trim() !== '';

const parseOffsetMinutes = (...values: unknown[]): number | null => {
  for (const value of values) {
    if (!isPresent(value)) {
      continue;
    }

    const text = String(value).trim();
    if (!/^[+-]?\d+$/.test(text)) {
      continue;
    }

    const minutes = Number(text);
    if (Number.isFinite(minutes) && Math.abs(minutes) <= 14 * 60) {
      return minutes;
    }
  }

  return null;
};

const firstZoneName = (...values: unknown[]): string | null => {
  const names = values
    .filter(isPresent)
    .map((value) => String(value).trim())
    .filter((value) => !/^[+-]?\d+$/.test(value));

  const ianaZone = names.find((value) => value.includes('/'));
  if (ianaZone) {
    return ianaZone;
  }

  return names[0] || null;
};

export const formatUtcOffset = (minutes: number): string => {
  const sign = minutes >= 0 ? '+' : '-';
  const absoluteMinutes = Math.abs(minutes);
  const hours = Math.floor(absoluteMinutes / 60);
  const remainder = absoluteMinutes % 60;
  return `UTC${sign}${String(hours).padStart(2, '0')}:${String(remainder).padStart(2, '0')}`;
};

export const formatRtuTimeZone = ({
  headerTimeZone,
  deviceTimeZone,
  timeZoneCountry,
}: {
  headerTimeZone?: string | number | null;
  deviceTimeZone?: string | number | null;
  timeZoneCountry?: string | null;
}): string => {
  const offsetMinutes = parseOffsetMinutes(headerTimeZone, deviceTimeZone);
  const zoneName = firstZoneName(timeZoneCountry, deviceTimeZone, headerTimeZone);

  if (offsetMinutes === null) {
    return zoneName || '—';
  }

  const offset = formatUtcOffset(offsetMinutes);
  const details = `${offset}; RTU offset: ${offsetMinutes} min`;
  return zoneName ? `${zoneName} (${details})` : details;
};
